import React, { Fragment } from 'react';
import { Field } from 'react-final-form';


function StatusSelect() {
    return (
        <Field
            name="status"
            component="select"
            className="form-control form-control-alternative"
        >
            <option value="">Todos</option>
            <option value="TRANSFER_SUCCESSFUL">Concluído</option>
            <option value="TRANSFER_PENDING">Em processamento</option>
            <option value="TRANSFER_FAILED">Falhou</option>
        </Field>
    );
}

export default StatusSelect;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Filters/StatusSelect.js